(function() {

    let app = angular.module('TetherApp');

    let CampaignVariableController = function (
        $window,
        $location,
        $anchorScroll,
        $scope
    ) {
        let self = this;
        self.campaignVariables = [];
        self.campaignId = null;

        self.init = function (campaignId) {
            self.campaignId = campaignId;
        	if(window.campaignVariables != undefined) {
				angular.forEach(window.campaignVariables, function( value, key ) {
	                self.campaignVariables.push(value);
	            }, self);
        	}
        };

        self.refresh = function(){
            // console.log(self.campaignVariables);
        };

        self.createCampaignVariable = function () {
            // console.log('create');
        	data = {};

            data.id = null;
        	data.campaign_id = self.campaignId;
        	data.key = self.newKey;
            data.value = self.newValue;

            self.campaignVariables.push(
                data
			);

            self.newKey = null;
            self.newValue = null;

        };

        self.deleteCampaignVariable = function(key) {
			self.campaignVariables.splice(key, 1);
        };
    };

    angular.module('TetherApp').controller('CampaignVariableController', [
        '$window',
        '$location',
        '$anchorScroll',
        '$scope',
        CampaignVariableController
    ]);
}());
